export default __webpack_public_path__ + "static/media/Dropdown.5c24b5ee.svg";